import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import TooltipInfo from "../../../../components/TooltipInfo";

const Tenant = ({ subscriptions }) => {
  const [defaultUnit, setDefaultUnit] = useState("metric");

  const handleUnitChange = (e) => {
    setDefaultUnit(e.target.value);
  };

  return (
    <div className="tenant-section mb-5 p-4 bg-light border rounded">
      <h5 className="text-white p-2" style={{ backgroundColor: "#243544" }}>
        Tenant
      </h5>
      <Row>
        <Col md={6}>
          <Form.Group controlId="tenantName" className="mb-4">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Form.Label style={{ whiteSpace: "nowrap" }}>Tenant Name (Alias)</Form.Label>
              <TooltipInfo tooltipText="This will setup the alias of the tenant. The actual name will be deduced from it." />
            </div>
            <Form.Control type="text" placeholder="Enter Tenant Alias" required />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="description" className="mb-4">
            <Form.Label>Description</Form.Label>
            <Form.Control type="text" placeholder="Enter Description" required />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group controlId="subscriptionId" className="mb-4">
            <Form.Label>Subscription</Form.Label>
            <Form.Select type="text" placeholder="Select Subscription" required>
              {subscriptions.map((subscription) => (
                <option key={subscription.id} value={subscription.id}>
                  {subscription.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="defaultUnit" className="mb-4">
            <Form.Label>Default Unit</Form.Label>
            <Form.Select value={defaultUnit} onChange={handleUnitChange} required>
              <option value="metric">Metric</option>
              <option value="imperial">Imperial</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default Tenant;
